import { render, staticRenderFns } from "./LaborProtectionAccidentForm.vue?vue&type=template&id=dbc43336&"
import script from "./LaborProtectionAccidentForm.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionAccidentForm.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionAccidentForm.vue?vue&type=style&index=0&id=dbc43336&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports